import React from 'react';
import { Modal } from "antd";
import  DetalhePlanoContaContabil  from '../../detalhePlanoContaContabil';

export default function ModalDetalhePlanoConta ({ exibirModal, fecharModal, dadosModal }) {
    return (
        <Modal
            open={exibirModal}
            destroyOnClose
            title="Detalhes do plano conta"
            width="70%"
            onCancel={() => fecharModal()}
            footer={null}
            >
                <DetalhePlanoContaContabil dadosModal={dadosModal}/>
        </Modal>
    )
}